var render = function render(){var _vm=this,_c=_vm._self._c;return _c('content-loader',{attrs:{"viewBox":"0 0 900 800","speed":2,"primaryColor":"#3333","secondaryColor":"#fff"}},[_c('rect',{attrs:{"x":"55","y":"6","rx":"4","ry":"4","width":"280","height":"150"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }